export default __webpack_public_path__ + "static/media/labels-explanation.22c3698c.png";